import IconEtfsPng from './icon-etfs.png';
import IconGoalPng from './icon-goal.png';
import IconPopupInfoPng from './icon-popup-info.png';
import RetirementPng from './retirement.png';

export { IconEtfsPng, IconGoalPng, IconPopupInfoPng, RetirementPng };
